import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Check: React.FC<IconComponentProps> = ({
  className,
  strokeWidth = '1.5',
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 5L6.125 12L3 8.81818"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
